import axios from "@/plugins/axios";

let url = "/api/console/auth";

export const auth = {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
}